import { customList, CountryProperty } from 'country-codes-list'

export const countryCode = Object.values(
    customList('countryCode' as CountryProperty, '+{countryCallingCode}')
).map((country) => country.replace(' ', '-'))
